import React, { useState } from 'react';
import { Button } from 'tdesign-react';
import LibsModal from './LibsModal';

/**
 * 手动更新版本
 *
 * @typedef {Object} Props
 * @property {string} componentStencilId - 组件样板的ID。
 * @property {number} [envId=0] - 环境的ID（默认值：0）。
 * @property {number} [clusterId=0] - 集群的ID（默认值：0）。
 * @property {number} [productLibId] - 制品库的ID。
 * @property {function} onFinish - 更新完成时调用的回调函数。
 * @return {JSX.Element} 渲染的组件。
 */
export default function MannualUpdateVersion({
  componentStencilId,
  envId = 0,
  productLibId,
  clusterId = 0,
  onFinish,
}) {
  const [visible, setVisible] = useState(false);

  const handleClose = (finish) => {
    setVisible(false);
    if (finish) {
      onFinish();
    }
  };
  return (
    <>
      <Button variant='outline' theme='primary' onClick={() => setVisible(true)}>
        手动更新版本
      </Button>
      <LibsModal
        componentStencilId={componentStencilId}
        envId={envId}
        clusterId={clusterId}
        productLibId={productLibId}
        visible={visible}
        handleClose={handleClose}
      />
    </>
  );
}
